/**
 * Parking-related constants
 */

export const PARKING_RESULT_CODE = {
    SCHEDULED_PARKING: 'E',
    RESULT_SUCCESS: 'S',
} as const;
